import { Immutable } from "immer";
import React from "react";
import { useFlickity } from "tsi-common-react/src/hooks/useFlickity";

import { templates } from "@reactivated";

type ICategory = templates.ProductListPageTemplate["categories"][number];

type IProps = Immutable<{
    categories: ICategory[];
}>;

// The category jump-nav is a Flickity carousel on mobile only (activated via
// `watchCSS` against `.product-list-nav__list::after { content: "flickity" }`).
// Flickity is initialized in an effect (post-hydration) rather than as a
// module-load side effect: on a full-document React page React owns this <ul>,
// so mutating it before hydrateRoot() would trigger a hydration mismatch and
// React would discard the carousel.
export const ProductListNav = (props: IProps): React.JSX.Element => {
    const listRef = React.useRef<HTMLUListElement>(null);
    useFlickity(listRef, {
        module: "flickity",
        options: {
            watchCSS: true,
            draggable: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: true,
        },
        enabled: props.categories.length > 0,
    });

    return (
        <nav className="product-list-nav">
            <ul ref={listRef} className="product-list-nav__list l-capped-width">
                {props.categories.map((category, i) => (
                    <li key={i} className="product-list-nav__item">
                        <a
                            href={`#${category.title}`}
                            className="product-list-nav__link"
                        >
                            {category.title}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};
